//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "backbone",
  "jquery",
  "marionette",
  "messaging/messenger",
  "./departmentDetailsView",
  "modules/accountAdmin/departmentAdmin/departmentModel",
  "./basicDepartmentInfo/basicDepartmentInfoModule",
  "./kbAndLocaleSelect/kbAndLocaleSelectModule",
  "./usersSelect/usersSelectModule",
  "modules/accountAdmin/departmentAdmin/departmentHistory/departmentHistoryModalModule",
], function (
  Backbone,
  $,
  Marionette,
  Messenger,
  DepartmentDetailsView,
  DepartmentModel,
  BasicDepartmentInfoModule,
  KbAndLocaleSelectModule,
  UsersSelectModule,
  DepartmentHistoryModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "kbRoleDetails";
      this.tenant = options.tenant;
      this._setUpVents();
    },
    show: function (options) {
      if (options.department) {
        this.department = options.department;
      } else if (options.departmentId) {
        const departments = Messenger.reqres.request("tenant:departments", {
          tenantId: this.tenant.id,
        });
        let departmentId = options.departmentId;
        departments.onSynced(function () {
          if (departmentId == "new") {
            const department = departments.addDepartment();
            departments.add(department);
            options.department = department;
            this.show(options);
            return;
          }
          departmentId = +departmentId;
          if (departmentId && !isNaN(departmentId)) {
            department = departments.get(departmentId);
            if (department) {
              options.department = department;
              this.show(options);
              return;
            }
          }
          Backbone.history.navigate("accountAdmin/tenants/" + this.tenant.id + "/departments", {
            trigger: true,
          });
        }, this);
        return;
      }
      if (this.department.isNew()) {
        Backbone.history.navigate("accountAdmin/tenants/" + this.tenant.id + "/departments/new");
      } else {
        Backbone.history.navigate(
          "accountAdmin/tenants/" + this.tenant.id + "/departments/" + this.department.id,
        );
        // Make sure we always have the latest version of the Department record
        this.department.fetch();
        this.department.users().fetch();
      }

      Messenger.onSave(function () {
        this.department.saveModel();
      }, this);

      this.layout = new DepartmentDetailsView.departmentDetailsLayout();
      this.kbs = Messenger.reqres.request("tenant:kbs", this.tenant.id);
      this.kbs.onSynced(function () {
        if (!this.kbs || !this.kbs.length) {
          Messenger.okDialog(
            $.t("admin.department.noKbsForTenant"),
            function () {
              Backbone.history.navigate("accountAdmin/tenants/" + this.tenant.id + "/departments", {
                trigger: true,
              });
            },
            this,
          );
          return;
        }
        let defaultKbId = Messenger.reqres.request("default:kbId");
        if (!this.kbs.get(defaultKbId)) {
          defaultKbId = this.kbs.at(0).id;
        }
        this.kbs.selectedId = defaultKbId;
      }, this);

      this.layout.on("delete:department", this._onDeleteDepartment, this);
      this.layout.on("show", this._showSubViews, this);
      this.basicDepartmentInfo = this.addSubModule(
        new BasicDepartmentInfoModule({
          region: this.layout.basicDepartmentInfo,
          tenant: this.tenant,
        }),
      );
      this.kbAndLocaleSelect = this.addSubModule(
        new KbAndLocaleSelectModule({
          region: this.layout.kbAndLocaleSelect,
          tenant: this.tenant,
        }),
      );
      this.usersSelect = this.addSubModule(
        new UsersSelectModule({
          region: this.layout.users,
          tenant: this.tenant,
        }),
      );
      this.showRegion(this.layout, { entities: [this.department, this.kbs], loading: true });
    },
    _onDeleteDepartment: function () {
      const model = this.department;
      Messenger.yesNoDialog(
        $.t("admin.department.confirmDeleteDepartment", { name: model.get("name") }),
        {
          yes: function () {
            Messenger.vent.trigger("track:interaction", {
              action: "Delete Department",
              id: model.id,
              idType: "Department",
              object: "Department",
              source: "Department Details",
            });
            Messenger.vent.trigger("cancel:textbox");
            model.deleteModel({
              success: function () {
                Messenger.vent.trigger("show:tenant:profile:departments");
              },
            });
          },
        },
        this,
      );
    },
    _onDepartmentHistory: function () {
      Messenger.vent.trigger(
        "show:modal",
        DepartmentHistoryModalModule,
        {
          editMode: false,
        },
        this.department,
        {
          title: $.t("admin.department.history"),
          closeButton: true,
          closeOnBackgroundClick: false,
          modalWidth: "900px",
          trackInteraction: {
            action: "Department History",
            id: this.department.id,
            idType: "Department",
            object: "Department",
          },
        },
      );
    },
    _showSubViews: function () {
      this.basicDepartmentInfo.show(this.department);
      this.kbs.onSynced(function () {
        this.kbAndLocaleSelect.show(this.kbs);
        this.usersSelect.show(
          this.department,
          this.kbAndLocaleSelect.getSelectedKbId(),
          this.kbAndLocaleSelect.getSelectedLocaleId(),
        );
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on("show:tenant:profile:department", this.show, this);
      Messenger.vent.on("department:history", this._onDepartmentHistory, this);
    },
  });
});
